<template>
  <div class="form-component">
    <v-form ref="form" v-model="valid">
      <h3 class="form-title">
        <v-btn fab color="primary" @click="goBack()">
          <v-icon large>arrow_left</v-icon>
        </v-btn>
        {{ title }} Proveedor
      </h3>

      <v-container fluid class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-text-field class="lance"
              label="Código"
              v-model="form.code">
            </v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field class="lance"
              label="Vendor Number"
              v-model="form.vendorNumber"
              :rules="[v => !!v || 'Campo requerido']">
            </v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
              solo
              label="Razón Social"
              v-model="form.businessName"
              :rules="[v => !!v || 'Campo requerido']">
            </v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
              solo
              label="RFC / Tax ID"
              v-model="form.rfc"
              :rules="[v => !!v || 'Campo requerido']">
            </v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
              solo
              label="Correo Electrónico"
              v-model="form.email"
              :disabled="view"
              :rules="[v => v === '' || /.+@.+/.test(v) || 'Campo no válido']">
            </v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
              solo
              label="Telefono"
              v-model="form.phone">
            </v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              solo
              v-model="form.supplierTypeId"
              :items="supplierTypes"
              item-text="name"
              item-value="id"
              label="Tipo de Proveedor"
              :rules="[v => !!v || 'Campo requerido']"></v-select>
          </v-flex>
          <v-flex hidden-xs md8></v-flex>
          <v-flex xs12 md4>
            <v-select
              solo
              v-model="form.countryId"
              :items="countries"
              item-text="name"
              item-value="id"
              label="Pais"
              @input="updateStates()"></v-select>
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              solo
              v-model="form.stateId"
              :items="states"
              item-text="name"
              item-value="id"
              label="Estado"
              :disabled="!form.countryId"
              @input="updateCities()"></v-select>
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              v-if="form.countryId == 42"
              solo
              v-model="form.cityId"
              :items="cities"
              item-text="name"
              item-value="id"
              label="Ciudad"
              :disabled="!form.countryId || !form.stateId || view"></v-select>

            <v-text-field
              v-if="form.countryId != 42"
              solo
              v-model="form.cityName"
              label="Ciudad"
              :disabled="!form.countryId || !form.stateId || view"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-btn v-if="!view" solo color="submitBtn" @click="save()" :disabled="!valid || sending">Guardar</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>


<script>
  import { events } from '../main';
  import { _ } from 'underscore';
  import moment from 'moment-timezone';
  import Swatches from 'vue-swatches'
  import IconPicker from './modals/icon-picker'
  import ImagePicker from './imagePicker';
  import ColorPicker from './colorPicker';
  import VueGridLayout from 'vue-grid-layout';

  export default {
    components: {
      ColorPicker,
      IconPicker,
      ImagePicker,
      Swatches,
    },
    data() {
      return {
        cities: [],
        countries: [],
        credentials: JSON.parse(localStorage.getItem('userCredentials')),
        form: {},
        id: '',
        layout: [],
        rowHeight: 15,
        sending: false,
        states: [],
        supplierTypes: [],
        title: 'Agregar',
        valid: true,
        view: false,
      }
    },
    methods: {
      dataInit() {
        const self = this;
        if (this.id) {
          this.getRegistry(this.id);
        } else {
          this.$http.get('Suppliers/form')
          .then(response => {
            const newform = response.body.Suppliers;
            this.form = newform;
            this.supplierTypes = response.body.types;
            this.countries = response.body.countries;
          });
        }
      },
      getRegistry(id) {
        const self = this;
        this.$http.get('Suppliers/form/' + this.id)
        .then(response => {
          self.form = response.body.Suppliers;
          this.supplierTypes = response.body.types;
          this.countries = response.body.countries;    
        }, error => {
          self.snackbar('Error al obtener registro');
          this.goBack();
        });
      },
      goBack () {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push('/');
      },
      goTo(url) {
        this.$router.push(url);
      },
      gridItem(id) {
        return this.layout.filter(x => x.i === id)[0];
      },
      save() {
        const self = this;
        if (this.$refs.form.validate()) {
          this.sending = true;
          this.form.updatedById = localStorage.getItem('userId');
          if (this.id) {
            this.$http.put('Suppliers/' + self.id, self.form)
              .then(response => {
                self.snackbar('Registro actualizado con éxito');
                this.goBack();                               
              }, error => {
                self.sending = false;                                
                let message = error.body.msg || 'Error al actualizar registro';
                self.snackbar(message);
                console.error(error);
              }
            );
          } else {
            self.form.createdById = localStorage.getItem('userId');
            self.$http.post('Suppliers/', self.form)
              .then(response => {
                self.snackbar('Registro creado con éxito');
                this.$router.push('/Supplierslist');   
              }, error => {
                self.sending = false;                                
                let message = error.body.msg || 'Error al crear registro';
                self.snackbar(message);
                console.error(error);
              }
            );
          }
        }
      },
      snackbar(message) {
        events.$emit('snackbar', message);            
      },
      updateCities() {
        this.cities = [];
        this.$http.get(`locations/getcities/${this.form.stateId}`).then(
          result => {
            this.cities = result.body;
          },
          error => {
            this.snackbar(error.msg || 'No se pudo obtener las ciudades del estado');
          }
        );
      },
      updateStates() {
        this.states = this.cities = [];
        this.$http.get(`locations/getstates/${this.form.countryId}`).then(
          result => {
            this.states = result.body;
          },
          error => {
            this.snackbar(error.msg || 'No se pudo obtener los estados del pais');
          }
        );
      }
    },
    mounted() {
      this.id = this.$route.params.id;
      if (this.$route.name.includes('detail') ) {
        this.view = true;
        this.title = 'Visualizar';
      } else if (this.$route.name.includes('edit')) {
        this.view = false;
        this.title = 'Modificar';
      }
      this.dataInit();
    },
    filters: {
      moment: function (date) {
        return moment(date).locale('es').format('LL');
      }
    },
    computed: {}
  }
</script>